<div [formGroup]="group()" class="select-style">

  @if (multiple()) {
  @if (label()) {
  <mat-label class="pb-2 label">{{label()}}@if (required()) {
    <sup class="required">*</sup>
    }</mat-label>
  }
  <mat-form-field class="w-full">
    <mat-select [placeholder]="placeholder()" (selectionChange)="onChange($event)" (removed)="onRemove($event)"
      [bindLabel]="labelKey()" [bindValue]="isWhole() ? '' : valueKey()" class="{{class()}}" [formControlName]="name()"
      multiple>
      @for (category of options(); track category) {
      <mat-option [bindLabel]="labelKey()" [value]="category.id">{{category[labelKey()]}}</mat-option>
      }
    </mat-select>
    @if (clearable() && formField?.value) {
    <button mat-icon-button matSuffix (click)="clearSelection()" style="color: #da0808;">
      <mat-icon>clear</mat-icon>
    </button>
    }
  </mat-form-field>
  }


  @if (!multiple() && !filter()) {
  @if (label()) {
  <mat-label class="pb-2 label">{{label()}}@if (required()) {
    <sup class="required">*</sup>
    }</mat-label>
  }
  @if (!multiple()) {
  <mat-form-field class="w-full">
    <mat-select [formControlName]="name()" (selectionChange)="onChange($event)"
      [bindValue]="isWhole() ? '' : valueKey()" [bindLabel]="labelKey()" [placeholder]="placeholder()">
      @if (options() && options().length) {
      @for (category of options(); track category) {
      <mat-option [value]="valueKey() ? category[valueKey()] : category.id" [bindLabel]="labelKey()">
        {{category[labelKey()]}}
      </mat-option>
      }
      }
    </mat-select>
    @if (clearable() && formField?.value) {
    <button mat-icon-button matSuffix (click)="clearSelection()" style="color: #da0808;">
      <mat-icon>clear</mat-icon>
    </button>
    }
    @if (formField?.errors && formField?.errors?.required) {
    <mat-error [ngClass]="{'error-outline': formField && formField.invalid
            && (isFormSubmitted() || (!formField.pristine && isErrorOnChange()))  }">
      {{label()}} is Required
    </mat-error>
    }
  </mat-form-field>
  }
  }
  @if (!multiple() && filter()) {
  @if (label()) {
  <mat-label class="pb-2 label">{{label()}}@if (required()) {
    <sup class="required">*</sup>
    }</mat-label>
  }
  @if (!multiple()) {
  <mat-form-field class="w-full">
    <mat-select [formControlName]="name()" (selectionChange)="onChange($event)"
      [bindValue]="isWhole() ? '' : valueKey()" [bindLabel]="labelKey()" [placeholder]="placeholder()">
      @for (category of options(); track category) {
      <mat-option [value]="category" [bindLabel]="labelKey()">
        {{category[labelKey()]}}
      </mat-option>
      }
    </mat-select>
    @if (clearable() && formField?.value) {
    <button mat-icon-button matSuffix (click)="clearSelection()">
      <mat-icon>clear</mat-icon>
    </button>
    }
    @if (formField?.errors && formField?.errors?.required) {
    <mat-error [ngClass]="{'error-outline': formField && formField.invalid
            && (isFormSubmitted() || (!formField.pristine && isErrorOnChange()))  }">
      {{label()}} is Required
    </mat-error>
    }
  </mat-form-field>
  }
  }

  <ng-template #elseTemplate>
    <div class="h-30 d-flex text-content align-items-center">
      {{value}} <!-- Accessing getter value -->
    </div>
  </ng-template>
</div>